export default "__VITE_ASSET__2VgqGcLl__"